var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"not-very-good-exp-main py-2",class:{ 'active': _vm.feedbackRating === 4 }},[_vm._v("😕"),_c('span',[_vm._v(_vm._s(_vm.$t('feedbackForm.notVeryGoodExp')))])])}
var staticRenderFns = []

export { render, staticRenderFns }